import React from "react";

/**
 * Primary UI component for user interaction
 */
const Button = ({
  text,
  background = "#407A28",
  size = "medium",
  label = "Button",
  disabled = false,
  textTransform = "lowercase",
  borderColor,
  fontWeight = "300",
  variant = "contained",
  fontSize = "14px",
  boxShadow,
  ...props
}) => {
  // Define size mappings
  const buttonSize = {
    small: "8px 14px",
    medium: "11px 20px",
    large: "12px 24px",
  };

  // Determine text color based on variant and other props
  const getTextColor = () => {
    if (variant === "outlined") {
      if (disabled) return "#E0E0E0";
      if (text) return text;
      if (borderColor) return borderColor;
      return background;
    } else if (variant === "contained") {
      if (disabled) return "#A6A6A6";
      if (text) return text;
      return background;
    }
    return "inherit";
  };

  // Determine background color
  const getBackgroundColor = () => {
    if (variant === "contained") {
      return disabled ? "#E0E0E0" : background;
    }
    return "transparent";
  };

  // Determine border style
  const getBorder = () => {
    if (variant === "outlined") {
      const borderColorValue = disabled ? "#E0E0E0" : borderColor ?? background;
      return `1px solid ${borderColorValue}`;
    }
    return "none";
  };

  // Combine all styles as inline style object
  const buttonStyle = {
    border: getBorder(),
    borderRadius: "4px",
    cursor: "pointer",
    display: "inline-block",
    lineHeight: "1",
    minWidth: "100px",
    outline: "none",
    fontSize: fontSize,
    fontWeight: fontWeight,
    textTransform: textTransform,
    boxShadow: boxShadow
      ? "0px 0px 2px rgba(0, 0, 0, 0.12), 0px 2px 2px rgba(0, 0, 0, 0.24)"
      : "none",
    color: getTextColor(),
    backgroundColor: getBackgroundColor(),
    padding: buttonSize[size],
  };

  return (
    <button type="button" style={buttonStyle} disabled={disabled} {...props}>
      {label}
    </button>
  );
};

Button.defaultProps = {
  background: "#3699FF",
  size: "medium",
  onClick: undefined,
};

export default Button;
